function elm_txtdb4_linkover(imgid) {
		document.getElementById(imgid).src='img/bullet_link_extern_over.gif';
}
	
function elm_txtdb4_linkout(imgid) {
	document.getElementById(imgid).src='img/bullet_link_extern.gif';
}